import { GUID, IElement } from "@faro-lotv/ielement-types";
import {
  // Using addIElements inside a wrapper function to be used everywhere else
  // eslint-disable-next-line no-restricted-imports
  addIElements,
  // Using moveIElement inside a wrapper function to be used everywhere else
  // eslint-disable-next-line no-restricted-imports
  moveIElement,
  // Using removeIElement inside a wrapper function to be used everywhere else
  // eslint-disable-next-line no-restricted-imports
  removeIElement,
} from "@faro-lotv/project-source";
import {
  // Using addLightweightElementsWithChildren only once inside the wrapper function
  // eslint-disable-next-line no-restricted-imports
  addLightweightElementsWithChildren,
  MoveElementArgs,
  // Using moveLightweightElement only once inside the wrapper function
  // eslint-disable-next-line no-restricted-imports
  moveLightweightElement,
  // Using only once the reducer below, to implement removeIElementFromStore
  // eslint-disable-next-line no-restricted-imports
  removeLightweightElement,
  toLightweight,
} from "./lightweight-elements-slice";
import { AppDispatch } from "./store";
/**
 * Adds iElements to the store, updating the lightweight iElements in the process
 *
 * @param iElements The iElements to add to the store
 * @param dispatch The app dispatch function
 */
export function addIElementsToStore(
  iElements: IElement[],
  dispatch: AppDispatch,
): void {
  dispatch(addIElements(iElements));
  const lightweightElements = iElements.map(toLightweight);
  dispatch(addLightweightElementsWithChildren(lightweightElements));
}

/**
 * Moves an element in the store, updating both the full iElements and the lightweight iElements slices
 *
 * @param param0 The arguments to move the element
 * @param dispatch The app dispatch function
 */
export function moveElementInStore(
  { id, newParentId, nextSibling }: MoveElementArgs,
  dispatch: AppDispatch,
): void {
  dispatch(moveIElement({ id, newParentId, nextSibling }));
  dispatch(moveLightweightElement({ id, newParentId, nextSibling }));
}

/**
 * Removes an iElement both from the iElements slice and the lightweightElements slice
 *
 * @param elementId The ID of the iElement to remove
 * @param dispatch The app dispatch function
 */
export function removeIElementFromStore(
  elementId: GUID,
  dispatch: AppDispatch,
): void {
  dispatch(removeIElement(elementId));
  dispatch(removeLightweightElement(elementId));
}
